module.exports = __webpack_public_path__ + "bundles/EventSubmission/assets/images/icons/megaphone-e20e7f90acbb83e39a8a5024b76189e1.svg";


//////////////////
// WEBPACK FOOTER
// ./app/client/bundles/EventSubmission/assets/images/icons/megaphone.svg
// module id = 622
// module chunks = 0